<template>
  <b-card>
    <!--<div
      v-if="mostraAvisoReajuste"
      class="aviso aviso-reajuste"
    >
      Existe(m) pacote(s) de serviços com valor(es) desatualizado(s)
    </div> -->
    <pacote-servico-lista
      ref="pacoteLista"
      class="lista-pacote"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :mostar-copia="true"
      :copiar="copiar"
      :exlusao-texto="'Atenção: Somente será realizada a remoção dos registros que não tenham vínculos com informações obrigatórias de outros cadastros. '
        + 'Caso tenha, esse registro será inativado. Deseja continuar?'"
      :filtros="filtros"
      filtrar-por-ativo
      @carregado="verificaReajuste($event)"
    >
      <template
        slot="botao-info"
        slot-scope="{props}"
      >
        <b-button
          :id="`infoBtn${props.row.id}`"
          v-b-tooltip.hover
          v-b-modal="`modalinfo${props.row.id}`"
          title="Informações"
          variant="none"
          :class="`${ props.row.desatualizado && !props.row.confirmado ? 'btn-info' : 'btn-outline-info' } btn-none rounded-pill icone-acao`"
          style="margin-right:0.3rem"
          @click="mostrarInfo = true"
        >
          <feather-icon icon="InfoIcon" />
        </b-button>
      </template>
      <template
        slot="info-adicional"
        slot-scope="{props}"
      >
        <div v-if="props.row.desatualizado && !props.row.confirmado">
          <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
          <div style="text-align: center;">
            <strong>Ocorrência de Alerta:</strong>
          </div>
          <div>
            <span>O valor do pacote de serviços está desatualizado, pois existem</span><br>
            <span>serviços com reajuste de valor. Faça uma cópia desse pacote</span><br>
            <span>para realizar a atualização dos valores.</span>
          </div>
        </div>
      </template>
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.field === 'valorPacote'">
          {{ parseFloat(props.row.valorPacote.toFixed(2)).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency', minimumFractionDigits: 2 }) }}
        </span>
      </template>
    </pacote-servico-lista>
  </b-card>
</template>

<style lang="scss">
.headerLeft {
  text-align: left !important;
}

.aviso-reajuste {
  text-align: center;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 1rem;

  p{
    margin:0
  }
}

.lista-pacote {
  .th-acao {
    width: 10.5rem !important;
  }
}
</style>

<script>
import api from '@/app-modulo/comercial/pacote-servico/shared/services/api'

export default {
  name: 'PacoteServicoVisualizacao',
  components: {
    PacoteServicoLista: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nome', type: 'personalizada', showActive: true, editable: true,
        },
        {
          label: 'Tipo de pacote', field: 'tipo',
        },
        {
          label: 'Competência',
          field: 'competencia',
          type: 'date',
          dateInputFormat: 'dd/MM/yyyy',
          dateOutputFormat: 'MM/yyyy',
          width: '170px',
          thClass: 'headerLeft',
          tdClass: 'text-left',
        },
        {
          label: 'Valor do Pacote',
          field: 'valorPacote',
          type: 'personalizada',
          width: '190px',
          thClass: 'text-left',
          tdClass: 'text-left',
        }],
      filtros: [{ colunas: ['Nome', 'Competencia', 'ValorPacote', 'Tipo'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      mostraAvisoReajuste: false,
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getPacotesServicos(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-pacote-servicos' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-pacote-servicos', params: { id: value.id } })
    },
    copiar(value) {
      this.$router.push({ name: 'copiar-pacote-servicos', params: { copia: true, id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deletePacoteServico(item.id)
            .then(payload => {
              resolve(!payload.data)
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    verificaReajuste(dados) {
      const reajuste = dados.find(f => f.desatualizado && !f.confirmado)
      this.mostraAvisoReajuste = reajuste !== undefined
    },
  },
}
</script>
